import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { GroupedBracketedDiv } from "../Logic/AndGroupEditor";
import { ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { DateLessThanExpression } from "../../../rule-engine-core/Expressions/Expressions/Date/DateLessThanExpression";

export class DateLessThanExpressionEditor extends ExpressionRuleEditor<DateLessThanExpression> {
    render() {
        return (
            <GroupedBracketedDiv issue={this.ruleData!.getValidationIssues()[0]}>
                <ExpressionPiece hasChild={!!this.ruleData!.value1!.subExpression}>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </ExpressionPiece>
                <ExpressionPiece> {"<"} </ExpressionPiece>
                <ExpressionPiece hasChild={!!this.ruleData!.value2!.subExpression}>
                    <ExpressionValueRenderer el={this.ruleData!.value2!} />
                </ExpressionPiece>
            </GroupedBracketedDiv>
        );
    }
}
